import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);
export default new Vuex.Store({
  state: {
    // personalInformation: {},
    uname: "",
    JSESSIONID: "",
    passWord: "",
    status: false,
    name: "",
    number: null,
    USER_ID: null,
    email: null,
    pay_status: null //0 未交费  1 已缴费  2免费
  },
  getters: {},
  mutations: {
    updateUser(state) {
      state.JSESSIONID = sessionStorage.getItem("JSESSIONID");
      state.uname = sessionStorage.getItem("uname");
      state.passWord = sessionStorage.getItem("password");
      state.status = sessionStorage.getItem("status");
      state.name = sessionStorage.getItem("name");
      state.number = sessionStorage.getItem("number");
      state.USER_ID = sessionStorage.getItem("USER_ID");
      state.email = sessionStorage.getItem("email");
      state.pay_status = sessionStorage.getItem("pay_status");
    }
  },
  actions: {},
  modules: {}
});



// WEBPACK FOOTER //
// ./src/store/index.js